import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourUploadDocApi = createApi({
  reducerPath: 'labourUploadDocApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourUploadDocApi'],
  endpoints: (builder) => ({

    uploadLabourDocument: builder.mutation({
        query(body) {
          return {
            url: spotFinder.labourUploadDocController.uploadLabourDocument,
            method: 'POST',
            headers: { Authorization: `Bearer ${body.token}`},
            body: body.payload, 
          };
        },
      }),

    saveLabourDocumentDetail: builder.mutation({
        query(body) {
            return {
              url: body.payload.isEdit
                ? `${spotFinder.labourUploadDocController.updateLabourDocumentDetail}${body.payload.id}` 
                : spotFinder.labourUploadDocController.saveLabourDocumentDetail, 
              method: body.payload.isEdit ? 'PUT' : 'POST',
              headers: { Authorization: `Bearer ${body.token}` }, 
              body: body.payload, // Pass the payload as the body
            };
          },
      }),
      updateLabourDocumentDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? `${spotFinder.labourUploadDocController.updateLabourDocumentDetail}${body.payload.id}`
            : spotFinder.labourUploadDocController.saveLabourDocumentDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteById: builder.mutation({
      query(body) {
        //console.log("Upload Body:",body);
        return {
          url: `${spotFinder.labourUploadDocController.deleteById}${body.payload.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getLabourDocumentsDetailsByLabourId: builder.mutation({
      query(body) {
       
        return {
          url: `${spotFinder.labourUploadDocController.getLabourDocumentsDetailsByLabourId}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});


export const {
  useUpdateLabourDocumentDetailMutation,
  useSaveLabourDocumentDetailMutation,
  useDeleteByIdMutation,
  useGetLabourDocumentsDetailsByLabourIdMutation,
  useUploadLabourDocumentMutation,
} = labourUploadDocApi;
